export default "__VITE_ASSET__DXZ6RVQf__"